import config from '../config';

if (typeof window !== 'undefined' && window.Sentry) {
  window.Sentry.init({
    dsn: config.SENTRY_DSN_FRONTEND,
    environment: config.APP_ENV,
    beforeSend: (event, hint) => {
      try {
        // This code (safely!) evals an arrow function - and if the browser
        // can't parse it, it will throw a syntax error. If that happens, then
        // the browser's old, and we don't want to get Sentry alerts from it.
        // eslint-disable-next-line no-new-func
        new Function('() => {}');
      } catch (error) {
        // Browser is old; ignore errors by returning null.
        // See https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-before-send
        return null;
      }

      const error = hint.originalException;

      if (error && error.extra) {
        if (event.extra) {
          event.extra = {
            ...event.extra,
            ...error.extra,
          };
        } else {
          event.extra = {
            ...error.extra,
          };
        }
      }

      return event;
    },
  });
}
